module.exports = "<router-outlet></router-outlet>\n<!-- /.o-collapsible-container -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/event/event-reports/event-reports.component.html
// module id = ./src/app/routes/event/event-reports/event-reports.component.html
// module chunks = 9